var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleColorfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_11354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0239 12.6547C24.0249 11.8369 23.9543 11.0206 23.8128 10.2147H12.2554V14.8363H18.8749C18.7395 15.5745 18.4528 16.2781 18.0321 16.9049C17.6115 17.5316 17.0655 18.0684 16.4273 18.483V21.483H20.3779C22.6911 19.3947 24.0239 16.3063 24.0239 12.6547Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2553 24.3813C15.5626 24.3813 18.3472 23.318 20.3779 21.4847L16.4272 18.4847C15.3277 19.2147 13.9115 19.6313 12.2553 19.6313C9.05873 19.6313 6.34554 17.5213 5.37533 14.678H1.30554V17.7697C2.32557 19.7571 3.88967 21.4279 5.82323 22.5954C7.75678 23.7629 9.98369 24.3812 12.2553 24.3813Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37537 14.678C4.86245 13.1881 4.86245 11.5746 5.37537 10.0847V6.99301H1.30558C0.4475 8.66493 0.000610352 10.5102 0.000610352 12.3813C0.000610352 14.2525 0.4475 16.0978 1.30558 17.7697L5.37537 14.678Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2553 5.13133C14.0031 5.10337 15.6918 5.74995 16.9566 6.93133L20.4545 3.50633C18.2365 1.46645 15.2981 0.346528 12.2553 0.381326C9.98369 0.381428 7.75678 0.999751 5.82323 2.16726C3.88967 3.33478 2.32557 5.00553 1.30554 6.99299L5.37533 10.0847C6.34554 7.24133 9.05873 5.13133 12.2553 5.13133Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_11354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.381348)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColorfull);
export default __webpack_public_path__ + "static/media/google-colorfull.09694fd6.svg";
export { ForwardRef as ReactComponent };